import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LoadingBoxWithoutText from "../../modules/shared/components/LoadingBoxWithoutText";

export default function SideProductAfterAddedCart(props) {
  // PROPS COMING FROM SideProductModalContent
  const {
    index,
    setScrollHeight,
    choosen,
    cartSkuItems,
    // width,
    loadingCart,
    cartSkuItemsLength,
    addedInCartRef,
  } = props;

  useEffect(() => {
    if (cartSkuItems.length > cartSkuItemsLength) {
      setTimeout(() => {
        addedInCartRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 1000);
    }
  }, [addedInCartRef, cartSkuItems, cartSkuItemsLength]);

  return (
    <div
      key={index}
      className="side-products-container"
      onClick={() => setScrollHeight("/urun")}
    >
      <p className="fs1 side-products-added">Teşekkürler Sepete Eklendi</p>
      <img
        className="item-product-img"
        src={choosen.skuImages[0]}
        alt="beddo"
      />
      {loadingCart === index && cartSkuItems.length > cartSkuItemsLength ? (
        <Link className="fs1 side-products-cart" to="/sepet">
          <i className="fas fa-cart-arrow-down fs15 beddo-color"></i>
          <button type="button" className="fs1 side-products-cart-button">
            Sepete Git
          </button>
        </Link>
      ) : (
        loadingCart === index && <LoadingBoxWithoutText />
      )}
    </div>
  );
}
